import { render, staticRenderFns } from "./TrustPilotReview.vue?vue&type=template&id=7e7ac618&scoped=true&"
import script from "./TrustPilotReview.vue?vue&type=script&lang=js&"
export * from "./TrustPilotReview.vue?vue&type=script&lang=js&"
import style0 from "./TrustPilotReview.vue?vue&type=style&index=0&id=7e7ac618&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e7ac618",
  null
  
)

export default component.exports